/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CloudOpsAutomationJobs {
    getFixupPrototypeFunction() { return CloudOpsAutomationJobs.fixupPrototype; }

    static newInstance(model: Partial<CloudOpsAutomationJobs>): CloudOpsAutomationJobs {
        let obj = Object.assign(new CloudOpsAutomationJobs(), model);
        CloudOpsAutomationJobs.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CloudOpsAutomationJobs>): CloudOpsAutomationJobs {
        if (!model) return null;
        return CloudOpsAutomationJobs.newInstance(<CloudOpsAutomationJobs> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CloudOpsAutomationJobs) {
        if (!obj) return;

        models.CloudOpsAutomationJobs.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CloudOpsAutomationJobs): boolean {
        Object.setPrototypeOf(obj, CloudOpsAutomationJobs.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Notify on scheduled job failures
     */
    scheduled_failures: boolean;

    /**
     * Notify on on-demand job failures
     */
    on_demand_failures: boolean;

}
